import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';

export const isFederatedResultsEnabled = (): boolean =>
	expVal<boolean>('fed_search_results_in_conf_fps', 'isEnabled', false);
